export const TNN_PERCENTAGE_DEFAULT = 40;

const tnnConfigs = {
  GT_PARTNER_OPT_IN: 'gt-partner-opt-in',
  ADMIN_TOGGLE: 'admin-toggle',
};

export default tnnConfigs;
